import React from "react";
import { CheckIcon } from "lucide-react";
import { Section } from "./Section";
import { SectionHeading } from "./SectionHeading";
import { blueprintIncludes } from "../data/included";
interface LaunchSectionProps {
  variant: "launch" | "final";
}
export function LaunchSection({
  variant
}: LaunchSectionProps) {
  const isFinal = variant === "final";
  return <Section tone={isFinal ? "navy" : "white"} cta={{
    label: isFinal ? "Get the GI Nutrition Blueprint now" : "Get the Blueprint now",
    sub: isFinal ? "$27 USD · One-Time Payment · No Recurring Subscription" : "$27 USD · One-Time Payment · Digital Product"
  }} data-id="element-207" data-mp="30b6cnj8jd5ml">
      <SectionHeading dark={isFinal} eyebrow={isFinal ? "Ready to organize your GI nutrition references?" : "The special launch offer"} title={isFinal ? "Bring your educational resources together in one place" : "Start building your organized GI nutrition reference library today"} intro={<>
            <p data-id="element-209" data-mp="1y50uaqpryxb0">You've invested time in developing your professional knowledge.</p>
            <p data-id="element-210" data-mp="225b1u7t7tvrz">
              Now you can {isFinal ? "organize" : "bring"} related educational references covering gastrointestinal physiology, nutritional assessment, dietary considerations, case analysis, nutrition care planning, and documentation {isFinal ? "within" : "into"} one {isFinal ? "collection" : "structured collection"}.
            </p>
          </>} data-id="element-208" data-mp="2mf2gvli0kp80" />
      <div className={`mx-auto mt-10 max-w-3xl rounded-3xl p-6 md:p-8 ${isFinal ? "bg-navy-900 ring-1 ring-white/10" : "bg-paper"}`} data-id="element-211" data-mp="1j6yt2n67unwx">
        <p className={`text-center text-xs font-bold uppercase tracking-[0.14em] ${isFinal ? "text-accent" : "text-brand"}`} data-id="element-212" data-mp="1o5s488y162tx">
          Your complete Blueprint includes
        </p>
        <ul className="mt-5 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-213" data-mp="2zlq9s2u026qe">
          {blueprintIncludes.map(item => <li key={item} className={`flex gap-2.5 text-[15px] leading-snug ${isFinal ? "text-white/90" : "text-ink"}`} data-id="element-214" data-mp="34jibtpocz98b">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-after text-white" data-id="element-215" data-mp="2euuvrjciysgt">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-216" data-mp="29z5nmrmfw38w" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
      <p className="mt-10 text-center font-display text-[26px] font-extrabold leading-tight md:text-4xl" data-id="element-217" data-mp="2jvs7pe6xyq9v">
        {isFinal ? "Get the complete collection for just " : "Your complete GI Nutrition Clinical Blueprint™ — just "}
        <span className={isFinal ? "text-cta" : "text-brand"} data-id="element-218" data-mp="1r4qo90w7u8kj">$27</span>
      </p>
    </Section>;
}